"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileLinkColumn = exports.ListLink = exports.LinkLabelSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("../../../../components/styles");
const LinkLabelSkeleton = exports.LinkLabelSkeleton = (0, _mui.styled)(_styles.UnifiedSkeleton)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize
}));
const ListLink = exports.ListLink = (0, _mui.styled)(_styles.UnifiedSkeleton)({
  height: '18px'
});
const MobileLinkColumn = exports.MobileLinkColumn = (0, _mui.styled)(_styles.UnifiedSkeleton)({
  width: '100%',
  height: '50px'
});
